import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Fades a label in when it replaces a placeholder, so the swap reads as the label arriving rather than a flicker.
 */
export function useLabelFadeIn(label: string | undefined, labelPending: boolean) {
  const [fadingIn, setFadingIn] = useState(false)
  const previousRef = useRef({ label, labelPending })

  // A layout effect so the new label never paints before the fade starts.
  useLayoutEffect(() => {
    const previous = previousRef.current
    previousRef.current = { label, labelPending }
    if (previous.labelPending && !labelPending && previous.label !== label) setFadingIn(true)
  }, [label, labelPending])

  return { fadingIn, onFadeInEnd: () => setFadingIn(false) }
}
